import React, { useState } from 'react';
import OrderDetailsStepper from '../../../../../../components/OrderDetailsStepper/OrderDetailsStepper';
import TruckDetailsMap from '../../../../../../containers/Admin/OrderDetails/components/AdditionalDetails/TruckDetailsMap';
import BaseOrderDetails from '../../../../../../components/BaseOrderDetails/BaseOrderDetails';
import DeliverySchedule from '../../AdditionalDetails/DeliverySchedule';
import ClientDeliveryDetails from '../../AdditionalDetails/ClientDeliveryDetails';
import { ClientOrderProps } from '../../../clientOrder.interface';
import OrderContractDetails from '../../../../../../components/OrderContractDetails/OrderContractDetails';
import { cn } from '../../../../../../lib/utils';

const CreatedStep: React.FC<ClientOrderProps> = (props) => {
	const { selectedOrder, contract, onBack, hideMap } = props;
	const [stepperMargin, setStepperMargin] = useState<number>(0);

	const handleWidthChange = (value: number) => {
		setStepperMargin(value);
	};

	return (
		<>
			<div
				style={{ marginBottom: `${stepperMargin}px` }}
				className={cn(onBack && 'mt-[96px]')}
			>
				<OrderDetailsStepper
					current={1}
					simpleOrder={selectedOrder?.trucks?.length === 1}
					order={selectedOrder}
					onWidthChange={handleWidthChange}
				/>
			</div>

			{!hideMap ? (
				<div className="px-10 pt-7 pb-3.5">
					<TruckDetailsMap selectedOrder={selectedOrder} mode="toDelivery" />
				</div>
			) : null}

			<div className={`px-10 ${hideMap ? 'pt-7 pb-3.5' : 'py-3.5'}`}>
				{contract ? (
					<OrderContractDetails
						selectedOrder={selectedOrder}
						contract={contract}
						target="customer"
					/>
				) : (
					<ClientDeliveryDetails
						selectedOrder={selectedOrder}
						simpleOrder={selectedOrder?.trucks?.length === 1}
					/>
				)}
			</div>

			{contract ? (
				<div className="px-10 py-3.5">
					<ClientDeliveryDetails
						selectedOrder={selectedOrder}
						simpleOrder={selectedOrder?.trucks?.length === 1}
					/>
				</div>
			) : null}

			<div className="px-10 py-3.5">
				<BaseOrderDetails
					selectedOrder={selectedOrder}
					isOpen={true}
					simpleOrder={selectedOrder?.trucks?.length === 1}
					deliveryIncluded={selectedOrder?.deliveryIncluded!}
					target={selectedOrder?.target!}
					contract={contract}
				/>
			</div>

			<div className="px-10 pb-7 pt-3.5">
				<DeliverySchedule
					selectedOrder={selectedOrder}
					deliveryIncluded={selectedOrder?.deliveryIncluded!}
					simpleOrder={selectedOrder?.trucks?.length === 1}
					step={1}
				/>
			</div>
		</>
	);
};

export default CreatedStep;
